<template>
    <va-create-layout>
        <ImagingServicesFeeEventFee-form
            :title="title"
            :item="item"
        ></ImagingServicesFeeEventFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
